const KEY = 'returnTo';

// Only an in-app path: "//host" and "/\host" are protocol-relative URLs, so accepting them is an open redirect.
export const isSafeReturnPath = path => typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');

// sessionStorage, not router state: the login can pass through MFA before it lands.
export const rememberReturnTo = path => {
  if (isSafeReturnPath(path) && !path.startsWith('/login')) sessionStorage.setItem(KEY, path);
};
export const takeReturnTo = fallback => {
  const path = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  return isSafeReturnPath(path) ? path : fallback;
};